import moment from 'moment';

export default class HolidayDateManager {
  constructor(holidays: moment.Moment[]) {
    this.holidays = holidays || [];
  }

  holidays: moment.Moment[];

  isHoliday = (date: moment.Moment): boolean =>
    this.holidays.some((holiday) => date.isSame(holiday, 'day'));

  nearHoliday(date = moment()): boolean {
    return this.holidays.some(
      (holiday) => Math.abs(holiday.diff(date, 'days')) <= 2,
    );
  }
}
